var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9285 9.628C17.8365 9.399 15.6115 4 9.9995 4C4.3875 4 2.1625 9.399 2.0705 9.628C1.9765 9.867 1.9765 10.133 2.0705 10.372C2.1625 10.601 4.3875 16 9.9995 16C15.6115 16 17.8365 10.601 17.9285 10.372C18.0225 10.133 18.0225 9.867 17.9285 9.628ZM9.9995 14C7.7905 14 5.9995 12.209 5.9995 10C5.9995 7.791 7.7905 6 9.9995 6C12.2095 6 13.9995 7.791 13.9995 10C13.9995 12.209 12.2095 14 9.9995 14ZM9.9995 8C8.8955 8 7.9995 8.896 7.9995 10C7.9995 11.104 8.8955 12 9.9995 12C11.1045 12 11.9995 11.104 11.9995 10C11.9995 8.896 11.1045 8 9.9995 8Z",
    fill: "#212B36"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9285 9.628C17.8365 9.399 15.6115 4 9.9995 4C4.3875 4 2.1625 9.399 2.0705 9.628C1.9765 9.867 1.9765 10.133 2.0705 10.372C2.1625 10.601 4.3875 16 9.9995 16C15.6115 16 17.8365 10.601 17.9285 10.372C18.0225 10.133 18.0225 9.867 17.9285 9.628ZM9.9995 14C7.7905 14 5.9995 12.209 5.9995 10C5.9995 7.791 7.7905 6 9.9995 6C12.2095 6 13.9995 7.791 13.9995 10C13.9995 12.209 12.2095 14 9.9995 14ZM9.9995 8C8.8955 8 7.9995 8.896 7.9995 10C7.9995 11.104 8.8955 12 9.9995 12C11.1045 12 11.9995 11.104 11.9995 10C11.9995 8.896 11.1045 8 9.9995 8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.b7e23d48.svg";
export { ForwardRef as ReactComponent };